import moment from 'moment-timezone/builds/moment-timezone-with-data-1970-2030'

// 24 time format
moment.defineLocale('it_24', {
  parentLocale: 'it',
  longDateFormat: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    L: 'DD/MM/YYYY',
    LL: 'D MMMM YYYY',
    LLL: 'D MMMM YYYY HH:mm',
    LLLL: 'dddd D MMMM YYYY HH:mm',
  },
})

moment.defineLocale('de_24', {
  parentLocale: 'de',
  longDateFormat: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    L: 'DD.MM.YYYY',
    LL: 'D. MMMM YYYY',
    LLL: 'D. MMMM YYYY HH:mm',
    LLLL: 'dddd, D. MMMM YYYY HH:mm',
  },
})

moment.defineLocale('eu_sky_24', {
  parentLocale: 'en-gb',
  longDateFormat: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    L: 'DD/MM/YYYY',
    LL: 'D MMMM YYYY',
    LLL: 'D MMMM YYYY HH:mm',
    LLLL: 'dddd, D MMMM YYYY HH:mm',
  },
})

moment.defineLocale('en_24', {
  parentLocale: 'en',
  longDateFormat: {
    LT: 'H:mm',
    LTS: 'H:mm:ss',
    L: 'MMMM D, YYYY',
    LL: 'YYYY-MM-DD',
    LLL: 'YYYY-MM-DD H:mm:ss',
    LLLL: 'dddd, MMM D [at] HH:mm:ss',
  },
})

// 12 time format
moment.defineLocale('it_12', {
  parentLocale: 'it',
  longDateFormat: {
    LT: 'h:mm A',
    LTS: 'h:mm:ss A',
    L: 'DD/MM/YYYY',
    LL: 'D MMMM YYYY',
    LLL: 'D MMMM YYYY h:mm A',
    LLLL: 'dddd D MMMM YYYY h:mm A',
  },
})

moment.defineLocale('de_12', {
  parentLocale: 'de',
  longDateFormat: {
    LT: 'h:mm A',
    LTS: 'h:mm:ss A',
    L: 'DD.MM.YYYY',
    LL: 'D. MMMM YYYY',
    LLL: 'D. MMMM YYYY h:mm A',
    LLLL: 'dddd, D. MMMM YYYY h:mm A',
  },
})

moment.defineLocale('eu_sky_12', {
  parentLocale: 'en-gb',
  longDateFormat: {
    LT: 'h:mm A',
    LTS: 'h:mm:ss A',
    L: 'DD/MM/YYYY',
    LL: 'D MMMM YYYY',
    LLL: 'D MMMM YYYY h:mm A',
    LLLL: 'dddd, D MMMM YYYY h:mm A',
  },
})

moment.defineLocale('en_12', {
  parentLocale: 'en',
  longDateFormat: {
    LT: 'h:mm A',
    LTS: 'h:mm:ss A',
    L: 'MMMM D, YYYY',
    LL: 'YYYY-MM-DD',
    LLL: 'YYYY-MM-DD h:mm:ss A',
    LLLL: 'dddd, MMM D [at] h:mm:ss A',
  },
})

export default moment
